module.exports = __webpack_public_path__ + "public/SiteIcons/Refresh.svg?5a6bb1d2";